import { loadOnInteraction } from "./includes/utils.js";
import adInit from "./libs/dotaudiences";
// import bcCategoryNav from "./includes/navigation";
import tbNavigation from "./includes/navigation";
import cf7Init from "./libs/cf7";
import footerCatAccordion from "./includes/footer";
import googleInit from "./libs/google";
// import header from "./includes/header";
import { lazyload } from "./modules/lazyload";

loadOnInteraction({
  callback: () => {
    // Google GA4
    googleInit();
    // Ad Units
    adInit();
    // Contact Form 7
    cf7Init();
  },
});
// Header | Mobile Menu
// bcCategoryNav();
tbNavigation();
// Footer | Accordion
footerCatAccordion();
// Close Search | Header
// header();
// Lazyload
lazyload();
